import { useNavigate, useLocation } from 'react-router-dom';
import { SegmentedControl } from '../../components/design-system';

const OPTIONS = [
  { value: 'login', label: 'Sign in' },
  { value: 'register', label: 'Register' },
];

/**
 * Sign in / Register toggle — replaces the old "Don't have an account?
 * Register" text link. Lives in the shared AuthLayout header area (not
 * per-screen) so its position and behavior stay identical across both auth
 * screens. Thin routing wrapper around the design-system SegmentedControl —
 * the visual/tone logic lives there, not here.
 */
export function AuthModeToggle() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isRegister = pathname.startsWith('/register');

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 28 }}>
      <SegmentedControl
        tone="inverted"
        aria-label="Sign in or register"
        options={OPTIONS}
        value={isRegister ? 'register' : 'login'}
        onChange={(mode) => navigate(`/${mode}`)}
      />
    </div>
  );
}

export default AuthModeToggle;
